webpackJsonp([72159030792731],{

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(3);
	
	var Disqus = function (_React$Component) {
	    _inherits(Disqus, _React$Component);
	
	    function Disqus() {
	        _classCallCheck(this, Disqus);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	
	        _this.disqus_config = function () {
	            if (typeof document !== 'undefined') {
	                var d = document,
	                    s = d.createElement('script');
	                s.src = 'https://senpaipathway.disqus.com/embed.js';
	                s.setAttribute('data-timestamp', new Date().toUTCString());
	                (d.head || d.body).appendChild(s);
	            }
	        };
	        return _this;
	    }
	
	    Disqus.prototype.render = function render() {
	        this.disqus_config();
	        return React.createElement("div", { className: "disqus" }, React.createElement("div", { id: "disqus_thread" }), React.createElement("noscript", null, "Please enable JavaScript to view the", ' ', React.createElement("a", { href: "https://disqus.com/?ref_noscript" }, "comments powered by Disqus.")));
	    };
	
	    return Disqus;
	}(React.Component);
	
	function Template(_ref) {
	    var data = _ref.data;
	    var markdownRemark = data.markdownRemark;
	
	    if (!markdownRemark) {
	        console.log(data);
	        return React.createElement("div", { className: "template" }); // For whatever reason gatsbyJS will load THIS file as a template too. zzz
	    }
	    var frontmatter = markdownRemark.frontmatter,
	        html = markdownRemark.html;
	
	    return React.createElement("div", { className: "lesson-post-container" }, React.createElement("div", { className: "lesson-post" }, React.createElement("h1", { className: "primary-text-color" }, frontmatter.title), React.createElement("div", { className: "lesson-post-content primary-text-color", dangerouslySetInnerHTML: { __html: html } })), React.createElement(Disqus, null));
	}
	exports.default = Template;
	exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-lesson-template-tsx-be597ef0f2531cfe1b0b.js